module.exports = __webpack_public_path__ + "media/mypage/images/logo_alt-53374d85d397f5b8dc600e7e6f122168.png";